// Currency display configuration (no conversion, just display toggle)
export const CURRENCY_LOCALES = {
  AED: 'AED',
  EGP: 'EGP'
};

// Currency display configuration
export const CURRENCY_CONFIG = {
  [CURRENCY_LOCALES.AED]: {
    code: 'AED',
    symbol: 'د.إ',
    name: 'UAE Dirham',
    displayName: 'Dirham',
    decimalPlaces: 2,
    thousandsSeparator: ',',
    decimalSeparator: '.',
    symbolPosition: 'before', // 'before' or 'after'
    showIcon: true // Shows Dhiram icons
  },
  [CURRENCY_LOCALES.EGP]: {
    code: 'EGP',
    symbol: 'ج.م',
    name: 'Egyptian Pound',
    displayName: 'EGP',
    decimalPlaces: 2,
    thousandsSeparator: ',',
    decimalSeparator: '.',
    symbolPosition: 'before', // 'before' or 'after'
    showIcon: false // Shows "EGP" text instead of icon
  }
};

// Default locale - can be overridden by user settings
export const DEFAULT_CURRENCY_LOCALE = CURRENCY_LOCALES.AED;
